var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "playstore",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.7,
    height: 29.983,
    viewBox: "0 0 26.7 29.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10227",
    "data-name": "Path 10227",
    d: "M1.053,18.855A2.742,2.742,0,0,0,.5,20.519V44.966a2.748,2.748,0,0,0,.48,1.563l13.3-13.874Zm0,0",
    transform: "translate(-0.5 -17.751)",
    fill: "#91298c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10228",
    "data-name": "Path 10228",
    d: "M48.1,13.632l4.315-4.5L37.247.374A2.733,2.733,0,0,0,35.129.1Zm0,0",
    transform: "translate(-33.101 0)",
    fill: "#91298c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10229",
    "data-name": "Path 10229",
    d: "M45.993,276.18l-13.1,13.667a2.721,2.721,0,0,0,.867.143,2.758,2.758,0,0,0,1.382-.375l15.277-8.82Zm0,0",
    transform: "translate(-30.994 -260.007)",
    fill: "#91298c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10230",
    "data-name": "Path 10230",
    d: "M286.537,173.955l-4.435-2.56-4.665,4.866,4.774,4.98,4.326-2.5a2.764,2.764,0,0,0,0-4.788Zm0,0",
    transform: "translate(-261.22 -161.358)",
    fill: "#91298c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d94694781b03443edface91b2b4d179c.svg";
export { ForwardRef as ReactComponent };